import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import AccordionItem, { AccordionItemProps } from '../../../helpers/AccordionItem/AccordionItem';
import { classnames } from 'tailwindcss-classnames';
import { useState } from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

export type AccordionProps = Sitecore.Override.ComponentBase &
  Components.General.Accordion.Fields.Accordion & {
    fields: {
      accordionItems: AccordionItemProps[];
    };
  };

const Accordion = ({ fields }: AccordionProps): JSX.Element => {
  const isPageEditing = useSitecoreContext().sitecoreContext.pageEditing;

  const [Open] = useState({
    Open: isPageEditing,
    Refresh: false,
  });
  if (!fields) {
    return <MissingDataSource />;
  }

  const accordionItems = fields.accordionItems.map((item) => {
    return {
      ...item,
    } as AccordionItemProps;
  });

  return (
    <div data-component="authorable/general/accordion">
      <div className={classnames('accordion')}>
        <ul
          className={classnames(
            'overflow-hidden',
            'relative',
            'max-w-screen-2xl',
            'relative',
            'mx-auto',
            'sm:flex-row',
            'sm:flex-row-reverse',
            'pt-1',
            'pb-12'
          )}
        >
          {accordionItems.map((accordionItem) => (
            <AccordionItem key={accordionItem.id} {...accordionItem} isOpen={Open} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Accordion;
